import forEach from 'lodash/forEach';

const triggerPLCCAnalytics = (plccAnalyticsAction, payload) => {
    /* istanbul ignore next */
    const handleCheckNow = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const payloadParams = {
            name: 'PLCC_APPLY_NOW_LINK',
            plccBanner: payload.plccBanner,
        };
        const targetURL = payload.href || event.target.href || event.currentTarget.href;
        plccAnalyticsAction(payloadParams);
        window.open(targetURL, '_blank');
    };
    const plccApplyButtons = document.querySelectorAll(
        '[data-plcc-id="at-link-plccBanner-id"],[data-automation-id="plcc-rewards-apply"],[data-automation-id="jcp_credit_card_apply_button"],[data-automation-id="plcc-banner-signin-slider"]'
    );
    /* istanbul ignore next */
    forEach(plccApplyButtons, (item) => {
        item.removeEventListener('click', handleCheckNow);
        item.addEventListener('click', handleCheckNow);
    });
};

export default triggerPLCCAnalytics;
